import type { QuizQuestion } from '../types/quiz'

export const questions: QuizQuestion[] = [
  {
    id: 1,
    prompt: 'Cuando piensas en tu ex, lo primero que sientes es...',
    options: [
      { key: 'A', text: 'Que fue tu culpa' },
      { key: 'B', text: 'Vacío, no siento nada' },
      { key: 'C', text: 'Rabia o ganas de que pague lo que hizo' },
      { key: 'D', text: 'Tristeza, pero ya la puedo sostener' },
      { key: 'E', text: 'Gratitud por lo que aprendí' },
    ],
  },
  {
    id: 2,
    prompt: '¿Cuántas veces al día revisas sus redes sociales?',
    options: [
      { key: 'A', text: 'Todo el tiempo, para ver si sufre como yo' },
      { key: 'B', text: 'Ya ni tengo ganas de revisar nada' },
      { key: 'C', text: 'Solo para ver si está con alguien más' },
      { key: 'D', text: 'De vez en cuando, sin obsesión' },
      { key: 'E', text: 'Casi nunca, no siento la necesidad' },
    ],
  },
  {
    id: 3,
    prompt: 'Cuando alguien te pregunta cómo estás, respondes...',
    options: [
      { key: 'A', text: '"Bien" aunque por dentro me siento un desastre' },
      { key: 'B', text: '"No sé, como que no siento nada"' },
      { key: 'C', text: '"Furioso/a, no puedo creer lo que me hizo"' },
      { key: 'D', text: '"Triste pero avanzando"' },
      { key: 'E', text: '"En paz, aprendiendo de esto"' },
    ],
  },
  {
    id: 4,
    prompt: '¿Sientes que mereces algo mejor?',
    options: [
      { key: 'A', text: 'No, siento que no hice lo suficiente' },
      { key: 'B', text: 'Ya ni me importa qué merezco' },
      { key: 'C', text: 'Sí, y él/ella no supo valorarme' },
      { key: 'D', text: 'Sí, y estoy trabajando en creerlo de verdad' },
      { key: 'E', text: 'Sí, y ya lo estoy viviendo' },
    ],
  },
  {
    id: 5,
    prompt: 'Cuando piensas en el futuro amoroso...',
    options: [
      { key: 'A', text: 'Siento que voy a arruinarlo otra vez' },
      { key: 'B', text: 'No me imagino queriendo a nadie más' },
      { key: 'C', text: 'Pienso en demostrarle que puedo estar mejor sin él/ella' },
      { key: 'D', text: 'Tengo esperanza, aunque con cautela' },
      { key: 'E', text: 'Me emociona, sin miedo' },
    ],
  },
  {
    id: 6,
    prompt: '¿Qué tanto repites la historia de la ruptura en tu cabeza?',
    options: [
      { key: 'A', text: 'Constantemente, buscando qué hice mal' },
      { key: 'B', text: 'Ya no la repito, solo siento cansancio' },
      { key: 'C', text: 'Constantemente, recordando lo que me hizo' },
      { key: 'D', text: 'A veces, pero ya sin engancharme tanto' },
      { key: 'E', text: 'Rara vez, ya la puedo ver con perspectiva' },
    ],
  },
  {
    id: 7,
    prompt: 'Si tu ex te pidiera perdón hoy...',
    options: [
      { key: 'A', text: 'Le pediría perdón yo también por no ser suficiente' },
      { key: 'B', text: 'No me generaría ninguna emoción' },
      { key: 'C', text: 'No lo aceptaría, quiero que sienta lo que yo sentí' },
      { key: 'D', text: 'Lo escucharía, pero sin necesitarlo para sanar' },
      { key: 'E', text: 'Lo recibiría en paz, sin resentimiento' },
    ],
  },
  {
    id: 8,
    prompt: '¿Cómo describes tus noches?',
    options: [
      { key: 'A', text: 'Pensando en qué pude hacer diferente' },
      { key: 'B', text: 'Sin energía para nada, solo quiero dormir' },
      { key: 'C', text: 'Dándole vueltas a lo injusto que fue todo' },
      { key: 'D', text: 'Algunas difíciles, pero ya duermo mejor' },
      { key: 'E', text: 'Tranquilas, en paz conmigo mismo/a' },
    ],
  },
  {
    id: 9,
    prompt: '¿Sientes que puedes confiar en ti mismo/a para tu próxima relación?',
    options: [
      { key: 'A', text: 'No, siento que siempre arruino todo' },
      { key: 'B', text: 'No tengo fuerzas para pensar en eso' },
      { key: 'C', text: 'Sí, pero desconfío de los demás' },
      { key: 'D', text: 'Estoy reconstruyendo esa confianza poco a poco' },
      { key: 'E', text: 'Sí, plenamente' },
    ],
  },
  {
    id: 10,
    prompt: 'Cuando alguien te dice "ya suéltalo"...',
    options: [
      { key: 'A', text: 'Siento que tienen razón, soy yo el problema' },
      { key: 'B', text: 'Simplemente no reacciono, es como si no importara' },
      { key: 'C', text: 'Me da rabia que no entiendan lo que me hicieron' },
      { key: 'D', text: 'Lo intento, aunque a veces cuesta' },
      { key: 'E', text: 'Ya lo solté, de verdad' },
    ],
  },
  {
    id: 11,
    prompt: '¿Qué tanto sientes que tu identidad depende de esa relación?',
    options: [
      { key: 'A', text: 'Siento que sin él/ella no valgo lo mismo' },
      { key: 'B', text: 'Siento que ya no sé ni quién soy' },
      { key: 'C', text: 'Siento que tengo que demostrar que estoy mejor sin él/ella' },
      { key: 'D', text: 'Estoy redescubriendo quién soy, aparte de la relación' },
      { key: 'E', text: 'Sé perfectamente quién soy, con o sin pareja' },
    ],
  },
  {
    id: 12,
    prompt: 'Si tuvieras que ponerle una palabra a cómo te sientes hoy...',
    options: [
      { key: 'A', text: 'Culpable' },
      { key: 'B', text: 'Vacío/a' },
      { key: 'C', text: 'Enojado/a' },
      { key: 'D', text: 'En proceso' },
      { key: 'E', text: 'En paz' },
    ],
  },
]
